var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighRiskManagementRolesCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ypba3cs4ha",
    d: "M0 0h11.415v16.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9dhg1lmbzc",
    d: "M0 0h9.9v9.41H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.196 1.667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4ewwjhqmxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ypba3cs4ha"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.695 3.571v4.167h2.97a1.786 1.786 0 0 1 1.78-1.786h1.188a1.786 1.786 0 0 1 1.782 1.786v1.19c0 .474-.188.928-.522 1.263a1.779 1.779 0 0 1-1.26.523H8.446a1.788 1.788 0 0 1-1.782-1.786H3.695v4.167a.597.597 0 0 0 .594.595h2.375a1.786 1.786 0 0 1 1.782-1.785h1.187a1.786 1.786 0 0 1 1.782 1.786v1.19c0 .474-.188.928-.522 1.263a1.779 1.779 0 0 1-1.26.523H8.446a1.788 1.788 0 0 1-1.782-1.786H4.29a1.779 1.779 0 0 1-1.713-1.296 1.789 1.789 0 0 1-.069-.49V8.93H.631L0 7.739h2.507V3.57A1.786 1.786 0 0 1 4.29 1.786h2.375A1.786 1.786 0 0 1 8.446 0h1.187a1.786 1.786 0 0 1 1.782 1.786v1.19c0 .474-.188.928-.522 1.263a1.779 1.779 0 0 1-1.26.523H8.446a1.788 1.788 0 0 1-1.782-1.786H4.29a.593.593 0 0 0-.594.595",
    fill: "#AEB3B7",
    mask: "url(#4ewwjhqmxb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61 4.772)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6xvw6edkmd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9dhg1lmbzc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m4.95 6.452-.89-2.976H5.84l-.89 2.976zm0 1.786a.593.593 0 0 1-.593-.596.596.596 0 0 1 .594-.595.593.593 0 0 1 .593.595.596.596 0 0 1-.593.596zM5.476.316a.595.595 0 0 0-1.049 0L.07 8.536a.596.596 0 0 0 .525.874h8.713a.593.593 0 0 0 .524-.875L5.475.315z",
    fill: "#AEB3B7",
    mask: "url(#6xvw6edkmd)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskManagementRolesCs);
export default __webpack_public_path__ + "static/media/high-risk-management-roles-cs.5228c5a6.svg";
export { ForwardRef as ReactComponent };